const DrawableCheckMark = (props: { className?: string }) => (
  <svg version="1.1" viewBox="0 0 231 219" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <marker orient="auto" refX="0.0" refY="0.0" style={{ overflow: 'visible' }}>
        <path
          d="M -2.5,-1.0 C -2.5,1.7600000 -4.7400000,4.0 -7.5,4.0 C -10.260000,4.0 -12.5,1.7600000 -12.5,-1.0 C -12.5,-3.7600000 -10.260000,-6.0 -7.5,-6.0 C -4.7400000,-6.0 -2.5,-3.7600000 -2.5,-1.0 z "
          style={{ fillRule: 'evenodd', fill: 'context-stroke', stroke: 'context-stroke', strokeWidth: '1.0pt' }}
          transform="scale(0.8) translate(7.4, 1)"
        />
      </marker>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath2159">
        <path d="M 228.813,1.89999 228.771,1.85995 C 227.528,0.661634 225.865,-0.00272373 224.138,0.00894009 222.968,0.0485025 221.818,0.320548 220.755,0.809172 219.691,1.2978 218.736,1.99323 217.944,2.85495 L 180.133,39.628 c -7.763,7.962 -15.655,15.9239 -23.288,23.6229 l -0.07,0.0711 c -13.226,13.344 -26.9,27.1429 -40,41.019 L 76.92,144.084 75.895,143.252 C 71.464,139.66 66.882,135.945 62.185,132.46 L 46.85,121.08 c -2.289,-1.7 -4.106,-3.1 -5.719,-4.4 -4.508,-3.639 -11.436,-7.975 -18.845,-7.975 -3.9263,-0.024 -7.7473,1.269 -10.853,3.671 l -0.313,0.237 c -14.77301,11.226 -12.106015,21.435 -7.26702,28.025 l 0.12101,0.165 63.10801,70.816 c 4.279,4.855 9.382,7.373 14.757,7.373 4.7,0 7.873,-2.5 10.257,-5.27 0,0 2.421,-3.263 2.59,-3.528 l 6.876,-10.558 13.323,-19.974 111.086,-164.0451 0.1,-0.1489 c 3.47,-5.227 6.292,-10.19901 2.742,-13.56801 z" />
      </clipPath>
    </defs>
    <path
      className={props.className}
      clipPath="url(#clipPath2159)"
      d="m 24.273399,134.3128 c 15.642451,14.11312 41.286102,29.24767 56.63793,58.25616 C 98.39852,152.60945 133.48392,109.52453 220.61822,17.800492"
      style={{
        strokeWidth: '55',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeMiterlimit: '4',
      }}
    />
  </svg>
);

export default DrawableCheckMark;
